<template>
  <div>
    <div class="row mt-4">

      <div class="col-md-12 col-12 form-field">
        <div class="row">
          <div class="col-md-8 col-12" style="font-size: 20px;">
            Payment details
          </div>
        </div>

        <purchase-order-input :form-type="formType"
							  :po-number="oneTimeSupplierPayment.poNumber"
							  @onPurchaseOrderEntered="onPurchaseOrderEntered"></purchase-order-input>

        <div class="pb-2">
          <div class="title mt-3 required-field">
            <span>{{FORM_LABELS.COMPANY_AND_CODE_NAME}}</span>
          </div>
          <div class="my-2">
            <div class="item select-style">
              <model-list-select
                  :list="companyCodeAndNameList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="oneTimeSupplierPayment.companyCode"
                  v-model="companyCodeAndName"
                  @input="buildAdditionalFormData"
                  v-validate="'required'"
                  :isDisabled="true"
                  id="companyCodeAndNameList"
              />
              <div v-if="oneTimeSupplierPayment.supplierNumber" class="pt-1">
                One time supplier ID: <strong>{{oneTimeSupplierPayment.supplierNumber}}</strong>
              </div>
              <show-errors
                  :for-item="'oneTimeSupplierPayment.companyCode'"
                  :formErrors="errors"
                  :field-name="FORM_LABELS.COMPANY_AND_CODE_NAME" />

            </div>
          </div>
        </div>



        <div class="title pt-2 required-field">
          <span>{{FORM_LABELS.ONE_TIME_SUPPLIER_NAME}}</span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="oneTimeSupplierPayment.supplierName"
              v-model="oneTimeSupplierPayment.supplierName"
              id="oneTimeSupplierPayment.supplierName"
              autocomplete="nope"
              v-validate="'required|max:70'"
          >
          <show-errors
              :for-item="'oneTimeSupplierPayment.supplierName'"
              :formErrors="errors"
              :field-name="FORM_LABELS.ONE_TIME_SUPPLIER_NAME" :max-length="70" />
        </div>


        <div class="title pt-2" v-if="isVatMandatory" >
          <span>{{FORM_LABELS.SUPPLIER_TAX_ID}} <span class="font-italic required-field">{{FORM_LABELS.SUPPLIER_TAX_ID_SUBDESC}}</span></span>
          <div class="mb-4 my-2">
            <input
                class="form-control"
                name="oneTimeSupplierPayment.supplierTaxId"
                v-model="oneTimeSupplierPayment.supplierTaxId"
                id="oneTimeSupplierPayment.supplierTaxId"
                autocomplete="nope"
                v-validate="{ required: this.isVatMandatory, max: 20 }"
            >
            <show-errors
                :for-item="'oneTimeSupplierPayment.supplierTaxId'"
                :formErrors="errors"
                :field-name="FORM_LABELS.SUPPLIER_TAX_ID" :max-length="20" />
          </div>
        </div>


        <div class="title pt-2">
          <span>{{FORM_LABELS.HOUSE_NO_STREET_NAME}}</span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="oneTimeSupplierPayment.houseNumber"
              v-model="oneTimeSupplierPayment.houseNumber"
              id="oneTimeSupplierPayment.houseNumber"
              autocomplete="nope"
              v-validate="'max:10'"
              data-vv-validate-on="input"
          >
          <show-errors
              :for-item="'oneTimeSupplierPayment.houseNumber'"
              :formErrors="errors"
              :field-name="FORM_LABELS.HOUSE_NO_STREET_NAME" :max-length="10" />
        </div>

        <div class="title pt-2">
          <span>{{FORM_LABELS.STREET_NAME}} <span class="font-italic">{{FORM_LABELS.CONTINUED}}</span></span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="oneTimeSupplierPayment.street"
              v-model="oneTimeSupplierPayment.street"
              id="oneTimeSupplierPayment.street"
              autocomplete="nope"
              v-validate="'max:60'"
              data-vv-validate-on="input"
          >
          <show-errors
              :for-item="'oneTimeSupplierPayment.street'"
              :formErrors="errors"
              :field-name="FORM_LABELS.STREET_NAME" :max-length="60" />
        </div>

        <div class="row no-gutters">
          <div class="col-md-6 col-12">
            <div class="title pt-2">
              <span>{{FORM_LABELS.CITY}}</span>
            </div>
            <div class="mb-4 my-2 pr-md-2 pr-0">
              <input
                  class="form-control"
                  name="oneTimeSupplierPayment.city"
                  v-model="oneTimeSupplierPayment.city"
                  id="oneTimeSupplierPayment.city"
                  autocomplete="nope"
                  v-validate="'max:40'"
                  data-vv-validate-on="input"
              >
              <show-errors
                  :for-item="'oneTimeSupplierPayment.city'"
                  :formErrors="errors"
                  :field-name="FORM_LABELS.CITY" :max-length="40" />
            </div>
          </div>

          <div class="col-md-6 col-12">
            <div class="title pt-2">
              <span>{{FORM_LABELS.ZIP}}</span>
            </div>
            <div class="mb-4 my-2 pr-md-2 pr-0">
              <input
                  class="form-control"
                  name="oneTimeSupplierPayment.postalCode"
                  v-model="oneTimeSupplierPayment.postalCode"
                  id="oneTimeSupplierPayment.postalCode"
                  autocomplete="nope"
                  v-validate="'max:10'"
                  data-vv-validate-on="input"
              >
              <show-errors
                  :for-item="'oneTimeSupplierPayment.postalCode'"
                  :formErrors="errors"
                  :field-name="FORM_LABELS.ZIP" :max-length="10" />
            </div>
          </div>

        </div>

        <div class="row no-gutters">
          <div class="col-md-6 col-12">
            <div class="title pt-2">
              <span>{{FORM_LABELS.COUNTRY}}</span>
            </div>
            <div class="item select-style mb-4 my-2 pr-md-2 pr-0">
              <model-list-select
                  :list="this.adminDataList.countryList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  id="oneTimeSupplierPayment.country"
                  name="oneTimeSupplierPayment.country"
                  v-model="countryValue"
                  @input="setCountryText"
                  v-validate="'required'"
              />
            </div>
          </div>

          <div class="col-md-6 col-12" v-if="isRegionRequired">
            <div class="pb-2">
              <div class="title mt-2 required-field">
                <span>{{FORM_LABELS.STATE}}</span>
              </div>
              <div class="my-2">
                <div class="item select-style">
                  <model-list-select
                      :list="formattedStateList"
                      :optionValue="'value'"
                      :optionText="'text'"
                      name="oneTimeSupplierPayment.region"
                      v-model="oneTimeSupplierPayment.region"
                      v-validate="'required'"
                      id="region"
                  />
                  <show-errors
                      :for-item="'oneTimeSupplierPayment.region'"
                      :formErrors="errors"
                      :field-name="FORM_LABELS.STATE" />

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pb-2">
          <div class="title mt-3 required-field">
            <span>{{FORM_LABELS.PAYMENT_REQUEST_AMOUNT}} <span class="font-italic">{{FORM_LABELS.INCL_TAX_VAT_IF_ANY}}</span></span>
          </div>
          <div class="my-2">
            <div class="item select-style row px-3">
              <model-list-select
                  :list="this.adminDataList.currencyList"
                  :optionValue="'value'"
                  :optionText="'text'"
                  name="oneTimeSupplierPayment.currency"
                  v-model="oneTimeSupplierPayment.currency"
                  class="amount-currency-field"
                  v-validate="'required'"
                  data-vv-validate-on="input"
              />
              <input
                  class="form-control d-inline amount-numeric-field"
                  name="oneTimeSupplierPayment.invoicedAmount"
                  @blur="formatAmount({event: $event, currencyValue: oneTimeSupplierPayment.currency, form: currentFormName, item: 'invoicedAmount' })"
                  v-model="oneTimeSupplierPayment.invoicedAmount"
                  id="oneTimeSupplierPayment.invoicedAmount"
                  autocomplete="nope"
                  v-validate.continues="{ required: true, max:maximumAmountCharLength, regex: CONSTANTS.POSITIVE_WITH_DECIMAL_AND_COMMAS }"
                  data-vv-validate-on="input"
              >
            </div>
            <validate-amount-decimals :amount="oneTimeSupplierPayment.invoicedAmount"
                                      :currency="oneTimeSupplierPayment.currency"
                                      @onValidationError="setInvoiceAmountInvalid" />
            <show-errors
                :for-item="'oneTimeSupplierPayment.currency'"
                :formErrors="errors"
                :field-name="FORM_LABELS.CURRENCY" />
            <show-errors
                :for-item="'oneTimeSupplierPayment.invoicedAmount'"
                :formErrors="errors"
                :field-name="FORM_LABELS.PAYMENT_REQUEST_AMOUNT" :max-length="maximumAmountCharLength" />
          </div>
        </div>


        <div class="title pt-2">
          <header-with-tooltip :tooltipText="invoiceDateToolTip" :show-icon="false">
            <span class="required-field">{{FORM_LABELS.INVOICE_DATE}}</span>
            <span class="solution-link font-italic">{{FORM_LABELS.INVOICE_DATE_HELP_TEXT}}</span>
          </header-with-tooltip>
        </div>
        <div class="mb-4 mt-1">
          <date-picker-widget
              v-model="oneTimeSupplierPayment.invoiceDate"
              class="col-xl-3 col-12 px-0"
              name="oneTimeSupplierPayment.invoiceDate"
              data-vv-validate-on="input"
              :id="'oneTimeSupplierPayment.invoiceDate'"
              v-validate="'required'"
              :label="'Select date'"
              :maxDate="lastDateOfMonth"
          ></date-picker-widget>
          <show-errors
              :for-item="'oneTimeSupplierPayment.invoiceDate'"
              :formErrors="errors"
              :field-name="FORM_LABELS.INVOICE_DATE"  />
        </div>


        <div class="title  required-field pt-2">
          <span>{{FORM_LABELS.INVOICE_REFERENCE_NUMBER}}</span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="oneTimeSupplierPayment.invoiceNumber"
              v-model="oneTimeSupplierPayment.invoiceNumber"
              id="oneTimeSupplierPayment.invoiceNumber"
              autocomplete="nope"
              v-validate.continues="{ required: true, max: 16 }"
              data-vv-validate-on="input"
          >
          <show-errors
              :for-item="'oneTimeSupplierPayment.invoiceNumber'"
              :formErrors="errors"
              :field-name="FORM_LABELS.INVOICE_REFERENCE_NUMBER" :max-length="16"  />
        </div>

        <div class="title pt-2">
          <span class="required-field">{{FORM_LABELS.PAYMENT_DUE_DATE}}</span>
          <header-with-tooltip
              :tooltip-text="FORM_LABELS.PAYMENT_DUE_DATE_SUBDESC"
              :isHTML="true"
              :show-icon="false">{{FORM_LABELS.PAYMENT_DUE_DATE_HELP_TEXT}}</header-with-tooltip>
        </div>
        <div class="mb-4 mt-1">
          <date-picker-widget
              v-model="oneTimeSupplierPayment.paymentDueDate"
              class="col-xl-3 col-12 px-0"
              name="oneTimeSupplierPayment.paymentDueDate"
              data-vv-validate-on="input"
              :id="'oneTimeSupplierPayment.paymentDueDate'"
              v-validate="'required'"
              :set-min-date="true"
              :label="'Select date'"
          ></date-picker-widget>
          <show-errors
              :for-item="'oneTimeSupplierPayment.paymentDueDate'"
              :formErrors="errors"
              :field-name="FORM_LABELS.PAYMENT_DUE_DATE"  />
        </div>

        <div class="title pt-2 required-field">
          <span>{{FORM_LABELS.DESCRIPTION_OF_PAYMENT}}</span>
        </div>
        <div class="mb-4">
          <textarea
              class="form-control w-100 mt-1 text-area-resize-none"
              name="oneTimeSupplierPayment.paymentTypeDescription"
              v-model="oneTimeSupplierPayment.paymentTypeDescription"
              v-validate="'required|max:50'"
          />
          <show-errors
              :for-item="'oneTimeSupplierPayment.paymentTypeDescription'"
              :formErrors="errors"
              :max-length="50"
              :field-name="FORM_LABELS.DESCRIPTION_OF_PAYMENT" />
        </div>

        <div class="title pt-2">
          <span>{{FORM_LABELS.SPECIAL_INSTRUCTIONS}}</span>
          <div class="font-italic">{{FORM_LABELS.SPECIAL_INSTRUCTIONS_SUBDESC}}</div>
        </div>
        <div class="mb-4">
          <textarea
              class="form-control w-100 mt-1 text-area-resize-none"
              name="oneTimeSupplierPayment.specialInstructions"
              v-model="oneTimeSupplierPayment.specialInstructions"
              v-validate="'max:60'"
          />
          <show-errors
              :for-item="'oneTimeSupplierPayment.specialInstructions'"
              :formErrors="errors"
              :max-length="60"
              :field-name="FORM_LABELS.SPECIAL_INSTRUCTIONS" />
        </div>

        <div>
          <attach-invoice :data="oneTimeSupplierPayment" @onInvoiceUploaded="onInvoiceUploaded($event, currentFormName)"
                          @onInvoiceDeleted="onInvoiceDeleted($event, currentFormName)"
                          :viewAttachment="true"
                          :multipleSelectionAllowed="true"
                          :max-file-size-in-mb="CONSTANTS.ATTACHMENTS_MAX_SIZE_IN_MB.INVOICE_PAYMENT_FORMS"
                          :is-required="true"
                          :attachment-title="CONSTANTS.ATTACH_AN_INVOICE"
                          :validFileTypes="CONSTANTS.FILE_TYPES.extensionAsPdf.validFileTypes"
                          :check-for-file-support="true" />
            <div class="text-danger input-error-text" v-if="showHelpTextForGermany">
              <b>XML e-invoice</b> is not accepted, please request and submit <b>PDF</b> format invoice.
            </div>
            <div class="text-danger input-error-text" v-if="showAttachmentsError">
              Invoice attachment is required
            </div>
        </div>

        <div class="float-md-right mt-4 pr-0">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome">Cancel</button>
          <button class="btn btn-outline-info outline-flat-btn submit-btn" @click="validateAndSetDraftRequest">Save Draft</button>
          <button class="btn-container btn flat-btn primary-blue-btn ml-2 my-3" @click="validateAmountsAndSetCurrentTab">Next</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import DatePickerWidget from "@/components/DatePicker";
import { mapGetters } from "vuex"
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import PurchaseOrderInput from "@/components/Payments/POBasedPayment/PurchaseOrderInput";
import CONSTANTS from "@/store/constants";
import AttachInvoice from "@/components/Payments/AttachInvoice";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";

export default {
  name: "OneTimeSupplierPaymentQuestionnaire",
  components: {DatePickerWidget, ModelListSelect, PurchaseOrderInput, AttachInvoice, HeaderWithTooltip},
  mixins: [PaymentFormsMixin],
  mounted() {
    if(!this.isFormDataLoaded) {
      this.resetOneTimeSupplierPaymentData()
    } else {
      this.setCompanyCodeAndTextField()
    }

    this.setIsInvalidPoNumber(true)
    //apply autocomplete to a random string so that browser do not suggest countries which overrides the dropdown.
    this.disableAutofill('oneTimeSupplierPayment.country')
  },
  data() {
    return {
      componentKey: 0,
      companyCodeAndName: '',
      countryValue: '',
      isVatMandatory: false,
      formType: CONSTANTS.ONE_TIME_SUPPLIER_API_FORM_TYPE,
      isRegionRequired: false,
      formattedStateList : [],
      showHelpTextForGermany: false,
    }
  },
  watch: {
    "oneTimeSupplierPayment.currency"(newVal) {
      let allowedDecimals =
          newVal ? this.adminDataList.currencyList.find(currency => currency.value === newVal).decimal : 2
      this.oneTimeSupplierPayment.invoicedAmount =
          this.oneTimeSupplierPayment.invoicedAmount ? this.updateAmount(this.oneTimeSupplierPayment.invoicedAmount, allowedDecimals) : ''
    },
  },
  computed: {
    ...mapGetters(['oneTimeSupplierPayment','isFormDataLoaded']),
  },
  methods: {
    validateAndSetDraftRequest() {
      this.$validator.attach({ name: "oneTimeSupplierPayment.poNumber", rules: {  required: true, min:10, max: 10, regex: /^([0-9]+)$/ }});
      this.$validator.validate('toBeReturnedPoNumber', this.oneTimeSupplierPayment.poNumber).then(result => {
        if (result) {
          this.saveDraftOneTimeSupplierPaymentRequest(true)
          //setIsFormDataLoaded is set to true to make sure that on first save to draft, the form in the background does not lose data in the form.
          this.setIsFormDataLoaded(true)
          //detach is for scenario when -- if none of the fields is entered, and save as draft is clicked , which attaches below validation , and if we press next after filling the fields
          //it will still show error, hence detach.
          this.$validator.detach("oneTimeSupplierPayment.poNumber");
        }else{
          window.scrollTo(0,0)

        }
      });
    },
    validateAmountsAndSetCurrentTab() {
      this.showAttachmentsError = !this.formAttachmentsExist(this.currentFormName)

      if(!this.isInvoiceAmountInvalid && !this.showAttachmentsError) {
        this.validateAndSetCurrentTab('PaymentDetailsForm')
      } else {
        this.$validator.validateAll(() => {})
        window.scrollTo(0,0)
      }
    },
    onPurchaseOrderEntered(respObject){
			this.oneTimeSupplierPayment.poNumber = respObject.poNumber;
			if(respObject.companyCode){
				this.oneTimeSupplierPayment.companyCode = respObject.companyCode
				this.setCompanyCodeAndTextField();
				this.oneTimeSupplierPayment.companyCodeText = this.getTextValue(this.adminDataList.companyCodeTextOptions, this.companyCodeAndName)
        this.buildDataBasedOnCompanyCode(this.oneTimeSupplierPayment.companyCode)
			}

			if(respObject.currency){
				let currencyObj = this.adminDataList.currencyList.find(currency => currency.text === respObject.currency)
				if(currencyObj) {
          this.oneTimeSupplierPayment.currency = currencyObj.value
        }
			}
			if(respObject.supplierName) {
        this.oneTimeSupplierPayment.supplierName = respObject.supplierName
      }
		},
    buildDataBasedOnCompanyCode(companyCode) {
      let supplierMetadata = this.adminDataList.companyCodeList.find(vendor => vendor.companyCode === companyCode)
      this.oneTimeSupplierPayment.supplierNumber = supplierMetadata.supplierId
      let countryCode = supplierMetadata.countryCode
      this.oneTimeSupplierPayment.country = this.getTextValue(this.adminDataList.countryList, countryCode)
      this.oneTimeSupplierPayment.currency = this.adminDataList.currencyList.find(currency => currency.text === supplierMetadata.currency).value
      this.isVatMandatory = supplierMetadata.isVatMandatory === 'R' ? true : false
      this.setCountryValue()
    },

    buildAdditionalFormData(index) {
      this.oneTimeSupplierPayment.companyCode = this.getTextValue(this.adminDataList.companyCodeOptions, index)
      this.oneTimeSupplierPayment.companyCodeText = this.getTextValue(this.adminDataList.companyCodeTextOptions, index)
      this.buildDataBasedOnCompanyCode(this.oneTimeSupplierPayment.companyCode)
    },

    setCompanyCodeAndTextField() {
      let companyCode = this.adminDataList.companyCodeOptions.find(company => company.text === this.oneTimeSupplierPayment.companyCode)
      this.companyCodeAndName = companyCode ? companyCode.value : ''
      this.showHelpTextForGermany = companyCode.text == "2060"
      this.setCountryValue()
    },

    setCountryText(index) {
      this.oneTimeSupplierPayment.country = this.getTextValue(this.adminDataList.countryList, index)
      this.validateAndSetStateRequired(this.oneTimeSupplierPayment.country)
    },
    validateAndSetStateRequired(country) {
      this.formattedStateList = []
      this.adminDataList.countryStateList.forEach(item => {
        if(item.countryName === country) {
          this.formattedStateList.push({text: item.regionName, value: item.region})
        }
      })
      this.isRegionRequired = this.formattedStateList.length !== 0;
    },
    setCountryValue() {
      let country = this.adminDataList.countryList.find(country => country.text === this.oneTimeSupplierPayment.country)
      this.countryValue = country ? country.value : ''
      this.validateAndSetStateRequired(this.oneTimeSupplierPayment.country)
    },
  }

}

</script>

<style scoped>
.preview-notification {
  margin-left: 0
}

.select-style >>> .ui.selection.dropdown .menu  {
  max-height: 150px;
}


.checkboxes-field label {
  display: block;
  padding-right: 10px;
  padding-left: 22px;
  text-indent: -22px;
}
.checkboxes-field input {
  vertical-align: middle;
}
.checkboxes-field label span {
  vertical-align: middle;
}

.currency-select {
  max-width: 70px;
}

.tax-team-container {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 40px 0 20px;
}

.tax-team-container span {
  background:#fff;
  padding:0 10px 0 0;
}

@media (max-width: 768px) {
  .expense-type-responsive {
    height: 50px;
  }
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>